(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-text"] && !Shopify.designMode) return;
  try {
    
(function() {

  function initTS(sectionEl) {
    if (!sectionEl) return;

    var slider = sectionEl.querySelector('.ts-slider');
    if (!slider) return;

    var slides = Array.from(slider.querySelectorAll('.ts-slide'));
    if (!slides.length) return;

    var prevBtn = sectionEl.querySelector('.ts-prev');
    var nextBtn = sectionEl.querySelector('.ts-next');

    /* FIX CRÍTICO — Dots solo dentro del mismo slider */
    var dotsContainer = sectionEl.querySelector('.ts-dots');
    var dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll('button')) : [];

    var wrapper = sectionEl.querySelector('.ts-card-wrapper');
    var autoplayMs = wrapper ? parseInt(wrapper.dataset.autoplay || "5000") : 5000;

    var index = 0;
    var timer = null;
    var animating = false;

    /* --- Update slide + dots --- */
    function update() {
      slider.style.transform = "translateX(" + (-index * 100) + "%)";

      if (dots.length) {
        dots.forEach(d => d.classList.remove('active'));
        if (dots[index]) dots[index].classList.add('active');
      }
    }

    /* --- Navigation core --- */
    function goTo(i) {
      if (animating) return;

      animating = true;

      /* FIX — wrap correcto */
      index = (i + slides.length) % slides.length;

      update();

      setTimeout(() => { animating = false; }, 450);
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }


    /* --- Buttons --- */
    if (nextBtn) nextBtn.addEventListener("click", function(e){
      e.preventDefault();
      next();
      resetTimer();
    });

    if (prevBtn) prevBtn.addEventListener("click", function(e){
      e.preventDefault();
      prev();
      resetTimer();
    });

    /* --- Dot events --- */
    dots.forEach((d, i) => {
      d.addEventListener("click", () => {
        goTo(i);
        resetTimer();
      });
    });

    /* --- Autoplay --- */
    function start() {
      stop();
      if (autoplayMs > 0) {
        timer = setInterval(next, autoplayMs);
      }
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    function resetTimer() {
      stop();
      start();
    }

    /* --- Touch swipe --- */
    var startX = 0, deltaX = 0, touching = false;

    slider.addEventListener("touchstart", function(e){
      touching = true;
      startX = e.touches[0].clientX;
      stop();
    }, {passive:true});

    slider.addEventListener("touchmove", function(e){
      if (!touching) return;
      deltaX = e.touches[0].clientX - startX;
    }, {passive:true});

    slider.addEventListener("touchend", function(){
      if (!touching) return;
      touching = false;

      if (Math.abs(deltaX) > 60) {
        deltaX < 0 ? next() : prev();
      }
      deltaX = 0;
      start();
    });

    /* Start slider */
    update();
    start();
  }

  /* Init on load */
  document.querySelectorAll('[id^="section-"]').forEach(section => {
    if (section.querySelector('.ts-slider')) {
      initTS(section);
    }
  });

  /* Init in editor */
  document.addEventListener('shopify:section:load', function(evt) {
    var section = evt.target;
    if (section && section.querySelector('.ts-slider')) {
      initTS(section);
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
